var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-home-page",style:(_vm.getStyle)},[_c('Nav'),_c('router-view',{staticStyle:{"min-height":"calc(100vh - 184px)"}}),_c('WebSiteInfo'),_c('SideService',{on:{"handleBackTop":_vm.handleBackTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }